(() => {
  'use strict';

  if (window.NaturaCollectionIntroductions) {
    window.NaturaCollectionIntroductions.init(document);
    return;
  }

  const initialized = new WeakSet();
  let nextId = 0;

  function enhance(introduction) {
    if (initialized.has(introduction) || introduction.dataset.collapseDescription === 'false') return;

    const content = introduction.querySelector('[data-introduction-content]');
    const toggle = introduction.querySelector('[data-introduction-toggle]');
    if (!content || !toggle) return;

    const nodes = Array.from(content.childNodes);
    const meaningful = nodes.filter(node => node.nodeType === 1 || (node.nodeType === 3 && node.textContent.trim()));
    const first = meaningful[0];
    const hasContent = paragraph => paragraph.textContent.trim() || paragraph.querySelector('img, video, iframe');
    const paragraphs = Array.from(content.children).filter(node => node.tagName === 'P' && hasContent(node));
    // Nested wrappers, leading headings/text, and single paragraphs stay fully visible.
    if (!first || first.tagName !== 'P' || !hasContent(first) || paragraphs.length < 2) return;

    const remainder = document.createElement('div');
    const originalControls = toggle.getAttribute('aria-controls');
    remainder.id = originalControls;
    while (!remainder.id || document.getElementById(remainder.id)) {
      remainder.id = 'CollectionIntroductionRemainder-' + (++nextId);
    }
    remainder.className = 'collection-introduction__remainder';

    const onToggle = () => {
      const expanding = remainder.hidden;
      remainder.hidden = !expanding;
      toggle.setAttribute('aria-expanded', String(expanding));
      toggle.textContent = expanding ? introduction.dataset.readLess : introduction.dataset.readMore;
      introduction.dataset.introductionExpanded = String(expanding);

      if (!expanding) {
        toggle.focus({ preventScroll: true });
        const bounds = toggle.getBoundingClientRect();
        if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
          toggle.scrollIntoView({ block: 'center', behavior: 'instant' });
        }
      }
    };

    try {
      // Move existing nodes, preserving markup, links, media, and their event listeners.
      content.appendChild(remainder);
      nodes.slice(nodes.indexOf(first) + 1).forEach(node => remainder.appendChild(node));
      toggle.addEventListener('click', onToggle);
      toggle.setAttribute('aria-controls', remainder.id);
      toggle.textContent = introduction.dataset.readMore;
      introduction.dataset.introductionExpanded = 'false';
      remainder.hidden = true;
      toggle.hidden = false;
      initialized.add(introduction);
    } catch (error) {
      // Leave the complete original description available if enhancement cannot finish.
      nodes.forEach(node => content.appendChild(node));
      remainder.remove();
      toggle.removeEventListener('click', onToggle);
      toggle.setAttribute('aria-controls', originalControls);
      toggle.hidden = true;
      delete introduction.dataset.introductionExpanded;
    }
  }

  function init(root) {
    const introductions = Array.from(root.querySelectorAll('[data-collection-introduction]'));
    if (root.matches && root.matches('[data-collection-introduction]')) introductions.unshift(root);
    introductions.forEach(enhance);
  }

  window.NaturaCollectionIntroductions = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
